export const registerRoyaltyTemplateBuilder = (Alpine) => {
    Alpine.data("royaltyTemplateBuilder", () => ({
        previewScrollLeft: 0,

        init() {
            this.$wire.on("royalty-template-scroll-to-column", ({ index }) => {
                this.$nextTick(() => {
                    const column = this.$root.querySelector(
                        `[data-royalty-column="${index}"]`,
                    );

                    column?.scrollIntoView({
                        behavior: "smooth",
                        block: "nearest",
                    });
                });
            });

            this.$root.addEventListener(
                "scroll",
                (event) => {
                    if (!(event.target instanceof HTMLElement)) {
                        return;
                    }

                    if (!event.target.hasAttribute("data-royalty-preview-scroller")) {
                        return;
                    }

                    this.previewScrollLeft = event.target.scrollLeft;
                },
                true,
            );

            Livewire.hook("commit", ({ succeed }) => {
                succeed(() => {
                    this.$nextTick(() => this.restorePreviewScroll());
                });
            });
        },

        restorePreviewScroll() {
            const scroller = this.$root.querySelector(
                "[data-royalty-preview-scroller]",
            );

            if (scroller instanceof HTMLElement) {
                scroller.scrollLeft = this.previewScrollLeft;
            }
        },
    }));
};
